import React from "react";
// Component
import { LoyaltyItemList } from "./item/LoyaltyItemList";
// Styled
import { ListContent, ListHeader, ListBody } from "./LoyaltyList.styled";

export const LoyaltyList = ({ historyList }) => {

    const history = historyList ? historyList : [];

    return (
        <ListContent>
            <ListHeader>Histórico de pontuação e consumo</ListHeader>
            <ListBody>
                {
                    history.map((hist, index) => (
                        <LoyaltyItemList key={index} item={hist} odd={Math.abs(index % 2) == 1} />
                    ))
                }
            </ListBody>
        </ListContent>
    )
}
